module.exports = __webpack_public_path__ + "img/null-gold-list.4f0278de.png";